import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@utils';

export const iconVariantConfig = {
	size: {
		xs: 'h-2 w-2',
		sm: 'h-2.5 w-2.5',
		md: 'h-3 w-3',
		lg: 'h-3.5 w-3.5',
		xl: 'h-4 w-4',
		'2xl': 'size-5',
	},
	color: {
		element: 'text-highlightElement',
		primary: 'text-primary',
		secondary: 'text-secondary',
		tertiary: 'text-tertiary',
        info: 'text-info',
	},
} as const;

const iconVariants = cva('flex items-center gap-1', { variants: iconVariantConfig });

export interface IconProps extends VariantProps<typeof iconVariants> {
	children: React.ReactElement;
	className?: string;
}

export const Icon = ({ children, className, size, color }: IconProps) => {
	return <span className={cn(iconVariants({ size, color }), className)}>{children}</span>;
};
